import { getTextsData } from "selectors/texts";
import { mainApi } from "api";
import { toast } from "react-toastify";
import MainApiRoutes from "const/MainApiRoutes";

export default class CustomPromptsActions {
  static FETCH_CUSTOM_PROMPTS_START = "customPrompts/FETCH_CUSTOM_PROMPTS_LIST_START";

  static FETCH_CUSTOM_PROMPTS_DONE = "customPrompts/FETCH_CUSTOM_PROMPTS_LIST_DONE";

  static FETCH_CUSTOM_PROMPTS_ERROR = "customPrompts/FETCH_CUSTOM_PROMPTS_LIST_ERROR";

  static UPDATE_CUSTOM_PROMPTS_START = "customPrompts/UPDATE_CUSTOM_PROMPTS_START";

  static UPDATE_CUSTOM_PROMPTS_DONE = "customPrompts/UPDATE_CUSTOM_PROMPTS_LIST_DONE";

  static UPDATE_CUSTOM_PROMPTS_ERROR = "customPrompts/UPDATE_CUSTOM_PROMPTS_LIST_ERROR";

  static fetchCustomPrompts(businessId) {
    return async(dispatch, getState) => {
      dispatch({ type: CustomPromptsActions.FETCH_CUSTOM_PROMPTS_START });

      const state = getState();

      const { errors } = getTextsData(state);

      const { BUSINESSES, CUSTOM_PROMPTS } = MainApiRoutes;

      const { result } = await mainApi.get(`${BUSINESSES}/${businessId}${CUSTOM_PROMPTS}`);

      if (result) {
        dispatch({
          type: CustomPromptsActions.FETCH_CUSTOM_PROMPTS_DONE,
          payload: result
        });

        return result;
      }
      dispatch({ type: CustomPromptsActions.FETCH_CUSTOM_PROMPTS_ERROR });
      toast.error(errors.whileLoadingCustomPrompts);

      return null;
    };
  }

  static updateCustomPrompts(businessId, customPrompts) {
    return async(dispatch, getState) => {
      dispatch({ type: CustomPromptsActions.UPDATE_CUSTOM_PROMPTS_START });

      const { BUSINESSES, CUSTOM_PROMPTS } = MainApiRoutes;

      const { errors } = getTextsData(getState());

      const { result } = await mainApi.patch(`${BUSINESSES}/${businessId}${CUSTOM_PROMPTS}`, null, customPrompts);

      if (result) {
        dispatch({ type: CustomPromptsActions.UPDATE_CUSTOM_PROMPTS_DONE, payload: customPrompts });

        return true;
      }
      dispatch({ type: CustomPromptsActions.UPDATE_CUSTOM_PROMPTS_ERROR });
      toast.error(errors.whileUpdatingCustomPrompts);

      return null;
    };
  }
}
